'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './apply-sub.routes';

export class ApplySubComponent {
  constructor(SubService, dialogs, $uibModal, $stateParams, Auth, Config, $http) {
    'ngInject';
    this.SubService = SubService;
    this.dialogs = dialogs;

    const generalConfig = Config.getModuleConfig(Config.Modules.General);

    const masterUrl = Config.getPlatformConfig().getMasterUrlWeb();

    $http({
      method: 'GET',
      url: masterUrl + '/api/settings/public/name/config.app'
    }).then(res => {
      let masterBusinessTypes = res.data.data.moduleConfig.general.businessTypes;
      let businessTypes = generalConfig.getBusinessTypes();
      let mergedAndSorted = [].concat(masterBusinessTypes, businessTypes).sort();
      this.businessTypes = [...new Set([... mergedAndSorted])];
    }, res => {
      this.businessTypes = generalConfig.getBusinessTypes();
    });

    this.groups = generalConfig.getGroups();
    this.selectedGroups = {};

    this.sub = {
      meta: {
        active: false
      }
    };
  }

  nothingSelected() {
    let keys = Object.keys(this.selectedGroups);

    if (keys.length == 0)
      return true;

    let o = keys.filter(key => this.selectedGroups[key]);

    return o.length == 0;
  };

  submit(form) {
    this.submitted = true;

    if (form.$valid) {

      let groups = this.groups.filter(group => this.selectedGroups[group.key]).map(group => group.key);

      this.sub.willSubFor = groups;

      return this.SubService.save(this.sub, () => {
        this.dialogs.notify("Your sub request has been sent", "Your sub request has been sent for review.<br/>Thank you!");
        this.submitted = false;
        this.selectedGroups = {};
        this.sub = {
          meta: {
            active: false
          }
        };
      });
    }
  }
}

export default angular.module('conduuApp.applySub', [uiRouter])
  .config(routes)
  .component('applySub', {
    template: require('./apply-sub.html'),
    controller: ApplySubComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/sub/apply/apply-sub.component.js